import { render, staticRenderFns } from "./CommonSampleStatusBadge.vue?vue&type=template&id=46453451&scoped=true&"
import script from "./CommonSampleStatusBadge.vue?vue&type=script&lang=js&"
export * from "./CommonSampleStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./CommonSampleStatusBadge.vue?vue&type=style&index=0&id=46453451&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46453451",
  null
  
)

export default component.exports